<template>
  <div v-if="pageShow">
    <div v-if="list.length">
      <ul class="tabs">
        <li
          v-for="(item, index) in list"
          @click="showChat(item, index)"
          :key="item.account"
          :class="{ on: index === current }"
        >
          <div class="avatar">
            <img class="ui-avatar" :src="item.url" style="object-fit: cover" />
            <!-- <el-image class="img" :lazy='true' :src="item.url" fit="cover" @error="resetImg(item.url)"></el-image> -->
          </div>
          <p class="name">{{ item.nickName }}</p>
        </li>
      </ul>
      <div class="msg-box">
        <!-- 对话中 -->
        <!-- <div class="user-info">
          <div class="avatar">
            <img
              v-if="!!list[current].url"
              class="ui-avatar"
              :src="list[current].url"
              style="object-fit: cover"
            />
          </div>
          <p class="name">
            {{ list[current].nickName }}
            {{ user.userType === 10 ? '老师' : '' }}
          </p>
          <p class="tip">In conversation</p>
        </div> -->
        <div class="msg-info" ref="wrap">
          <ul class="msg-list" ref="list">
            <li
              v-for="(item, index) in msgList"
              :key="index"
              :class="{ out: item.flow === 'out' }"
            >
              <p class="time" v-if="index === 0">{{ getTime(item.time) }}</p>
              <p
                class="time"
                v-else-if="item.time - msgList[index - 1].time > 5 * 60000"
              >
                {{ getTime(item.time) }}
              </p>
              <div class="msg-detial">
                <div class="avatar">
                  <img
                    class="ui-avatar"
                    :src="myAvatar"
                    v-if="item.flow === 'out'"
                    style="object-fit: cover"
                  />

                  <img
                    class="ui-avatar"
                    :src="list[current].url"
                    style="object-fit: cover"
                    v-else
                  />
                </div>
                <div class="msg-right">
                  <p
                    class="msg-text"
                    v-html="
                      !!item.text
                        ? item.text.replace(/\n|\r\n/g, '<br>')
                        : item.text
                    "
                  >
                    dwqdqw
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="enter-item">
          <div class="btn-item"></div>
          <textarea v-model="enterText" class="enter-box"></textarea>
          <div style="margin: 10px 0; text-align: right">
            <a class="ui-btn" @click="sendText">Send</a>
            <!-- <el-button @click="sendText" size="small" type="primary">Send</el-button> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 暂无消息 -->
    <div class="ui-empty" v-else>
      <!-- No data -->
    </div>
  </div>
</template>
<script>
import { getBaseInfo } from '@/service/studentApi.js'
import { getBaseProfile } from '@/service/teacherApi.js'
import { reloadErrorImg } from '@/service/util.js'
import moment from 'moment'
import SDK from '@/sdk/NIM_Web_SDK_v7.6.0.js'
let nim
export default {
  name: 'massage',
  data() {
    return {
      nim: '',
      list: [
        // {
        //   url:'http://121.idaguo.com/upload/edu/2020/07/24/20200724100408555.jpg',
        // },
      ],
      pageShow:false,
      current: 0,
      enterText: '',
      msgList: [],
      myAvatar: require('../assets/demo/photo.png'),
    }
  },
  watch: {
    // $route(to, from) {
    //   console.log(6666);
    //   this.myAvatar = this.user.userPhoto
    //   // this.myAvatar = this.user.userPhoto
    //   this.init(this.user.uid)
    //   // if (sessionStorage.getItem('session')) {
    //   //   this.list = JSON.parse(sessionStorage.getItem('session'))
    //   //   // this.getHistoryMsgs()
    //   // }
    //   if (sessionStorage.getItem('session')) {
    //     this.list = JSON.parse(sessionStorage.getItem('session'))
    //   }
    // },
    // $route: {
    //   immediate: true, // 一旦监听到路由的变化立即执行
    //   handler(to, from) {
    //     this.myAvatar = this.user.userPhoto
    //     // this.init(this.user.uid)
    //     // window.location.reload()
    //   },
    // },
    $route: {
      handler(newName, oldName) {
        this.pageShow=true;
      },
      deep: true,
    },
  },
  // mounted() {
  //   this.myAvatar = this.user.userPhoto
  //   this.init(this.user.uid)
  //   if (sessionStorage.getItem('session')) {
  //     this.list = JSON.parse(sessionStorage.getItem('session'))
  //     // this.getHistoryMsgs()
  //   }
  // },
  mounted() {
    this.pageShow=true;
    // console.log(this.$route.query.id);
    this.myAvatar = this.user.userPhoto
    this.init(this.user.uid)
    // this.init(this.user.uid)
    if (sessionStorage.getItem('session')) {
      this.list = JSON.parse(sessionStorage.getItem('session'))
    }
  },
  methods: {
    init(id) {
      nim = SDK.NIM.getInstance({
        appKey: '9a2fcc463062b50cb733cf7b500a8a79',
        account: id,
        token: sessionStorage.getItem('token3rd'),
        // token: '2c9a35855a1f90410a1aa81e9876abba',
        onconnect: this.onConnect,
        onwillreconnect: this.onwillreconnect,
        onmsg: this.onMsg,
        onmyinfo: this.onMyInfo,
        onsessions: this.onsessions,
        onSyncDone: this.onSyncDone,
      })
      // nim.deleteLocalSession({
      //   id: 'p2p-wukaida-test',
      //   done: this.deleteLocalSessionDone,
      // })
    },
    // deleteLocalSessionDone(error, obj) {
    //   console.log(error)
    //   console.log(obj)
    //   console.log('清除垃圾会话')
    // },
    onConnect() {
      if (this.$route.query.id) {
        nim.insertLocalSession({
          scene: 'p2p',
          to: this.$route.query.id,
          done: this.insertLocalSessionDone,
        })
      }
    },
    insertLocalSessionDone(error, obj) {
      // if (!error) {
      //   console.log(obj.session);
      //   this.onSessions(obj.session)
      // }
    },
    onwillreconnect(obj) {
      console.log('即将重连', obj)
    },
    onMsg(msg) {
      console.log(msg)
    },
    onMyInfo(user) {
      // console.log('获取我的信息', user)
    },
    async onsessions(sessions) {
      sessionStorage.setItem('session', JSON.stringify([]))
      if (sessions.length) {
        this.list = []
        for (let i = 0; i < sessions.length; i++) {
          if (sessions[i].to != this.$route.query.id) {
            let state = -1
            for (let j = 0; j < this.list.length; j++) {
              if (this.list[j].account === sessions[i].to) {
                state = j
              }
            }
            if (state !== -1) {
              this.list.splice(state, 1)
            }
            this.list[i] = {
              account: sessions[i].to,
              unread: sessions[i].unread,
            }
            await this.getUser(sessions[i].to, i)
          } else {
            // console.log(sessions[i])
            // console.log(this.list)
            this.list.push({
              unread: sessions[i].unread,
              account: sessions[i].to,
            })
            await this.getUser(sessions[i].to, i)
          }
        }
      }
      this.getHistoryMsgs()
    },
    // async getNewUser(id) {
    //   let res
    //   if (this.user.userType === 10) {
    //     res = await getBaseProfile({ teacherId: id })
    //     if (res.data.status === 1) {
    //       this.newLocalSessionDone=
    //     }
    //   } else {
    //     res = await getBaseInfo({ studentId: id })
    //     if (res.data.status === 1) {
    //       this.list.push({
    //         nickName: res.data.studentName,
    //         url: res.data.data.userPicUrl,
    //       })
    //     }
    //   }
    //   sessionStorage.setItem('session', JSON.stringify(this.list))
    //   this.$forceUpdate()
    // },
    async getUser(id, i) {
      let res
      // if(Number(id)===70){
      //   return false
      // }
      if (this.user.userType === 10) {
        res = await getBaseProfile({ teacherId: id })
        if (res.data.status === 1) {
          this.list[i].nickName = res.data.data.teacherName
          this.list[i].url = res.data.data.userPicUrl
        }
      } else {
        res = await getBaseInfo({ studentId: id })
        if (res.data.status === 1) {
          this.list[i].nickName = res.data.studentName
          this.list[i].url = res.data.userPicUrl
        }
      }
      sessionStorage.setItem('session', JSON.stringify(this.list))
      this.$forceUpdate()
    },
    sendMsgDone(error, msg) {
      if (!error) {
        this.enterText = ''
        this.msgList.push(msg)
        this.$nextTick(() => {
          this.$refs.wrap.scrollTop = 99999
        })
      } else {
        console.log('err')
        this.$message({ type: 'error', messsage: '信息发送失败，请重试' })
      }
    },
    getHistoryMsgs() {
      if (!!this.list[this.current].account) {
        nim.getHistoryMsgs({
          scene: 'p2p',
          to: this.list[this.current].account,
          done: this.getHistoryMsgsDone,
        })
      }
    },
    getHistoryMsgsDone(error, obj) {
      if (!error) {
        this.msgList = obj.msgs.reverse()
        this.$forceUpdate()
        this.$nextTick(() => {
          this.$refs.wrap.scrollTop = 99999
        })
      }
    },
    sendText() {
      console.log(this.list[this.current].account)
      if (this.enterText) {
        nim.sendText({
          scene: 'p2p',
          to: this.list[this.current].account,
          text: this.enterText,
          done: this.sendMsgDone,
        })
      }
    },
    getTime(time) {
      const today = new Date()
      if (moment(today).isSame(time, 'day')) {
        return moment(time).format('HH:mm')
      } else {
        return moment(time).format('DD/MM/YYYY HH:mm')
      }
    },
    showChat(item, index) {
      this.current = index
      this.getHistoryMsgs()
    },
    // resetImg(url) {
    //   console.log(url)
    //   url = 'http://121.idaguo.com/upload/edu/2020/07/24/20200724100408555.jpg'
    // },
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
}
</script>
<style lang="scss" scoped>
.tabs {
  overflow: hidden;
  li {
    float: left;
    width: 140px;
    height: 140px;
    border-radius: 10px 10px 0 0;
    background: #fff;
    cursor: pointer;
    &.on {
      background: #002147;
      .name {
        color: #fff;
      }
    }
    & + li {
      margin-left: 10px;
    }
  }
  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
    font-size: 0;
    margin: 26px auto 14px;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .name {
    color: #002147;
    text-align: center;
  }
}
.msg-box {
  background: #fff;
}
.user-info {
  height: 170px;
  border-bottom: 1px solid #eee;
  position: relative;
  padding: 60px 0 0 160px;
  font-size: 20px;
  line-height: 1;
  font-weight: bold;
  color: #333;
  .avatar {
    position: absolute;
    top: 50px;
    left: 50px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    font-size: 0;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .tip {
    margin-top: 20px;
  }
}
.msg-info {
  margin-top: 20px;
  height: 475px;
  overflow: auto;
}
.msg-list {
  color: #666;
  font-size: 16px;
  .time {
    margin-bottom: 15px;
    text-align: center;
  }
  li {
    padding: 20px 50px;
    &.out {
      .msg-detial {
        flex-direction: row-reverse;
      }
      .msg-text {
        background: #a9c4b1;
        color: #fff;
        float: right;
        &:before {
          display: none;
        }
        &:after {
          display: block;
        }
      }
    }
  }
  .avatar {
    width: 60px;
    height: 60px;
    font-size: 0;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .msg-right {
    flex: 1;
    padding: 0 20px;
  }
  .msg-text {
    display: inline-block;
    max-width: 100%;
    margin-left: 20px;
    background: #fbfbfb;
    border-radius: 5px;
    padding: 14px 50px;
    line-height: 32px;
    position: relative;
    word-break: break-all;
    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      margin-top: -6px;
    }
    &:before {
      left: -8px;
      border-right: 8px solid #fbfbfb;
    }
    &:after {
      right: -8px;
      border-left: 8px solid #a9c4b1;
      display: none;
    }
  }
}
.msg-detial {
  display: flex;
  align-items: center;
}
.enter-item {
  height: 250px;
  border-top: 1px solid #eee;
}
.btn-item {
  height: 104px;
  padding: 0 50px;
}
.enter-box {
  resize: none;
  height: 146px;
  width: 100%;
  border: 0;
  padding: 6px 50px;
  font-size: 16px;
  color: #666;
}
</style>